"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlagueAbilityHandler = exports.PlagueActorAbilityFactory = exports.PlagueAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class PlagueAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Plague;
        this.__typeName = "Plague";
    }
}
exports.PlagueAbilityArgs = PlagueAbilityArgs;
let PlagueActorAbilityFactory = class PlagueActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Plague", "AllEnemies", 2);
    }
};
PlagueActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Plague")
], PlagueActorAbilityFactory);
exports.PlagueActorAbilityFactory = PlagueActorAbilityFactory;
let PlagueAbilityHandler = class PlagueAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        container.applyMultiAttack({
            sequence,
            abilityKey: "Plague",
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies).map(targetId => ({
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 120)
                ],
                effects: [
                    {
                        duration: Duration_1.Duration.Turns(3),
                        effect: new core_1.DiseasedEffectArgs("Focus", 10),
                        targetId
                    }
                ],
                jitter: (0, Random_1.random)(100, 400),
                targetId
            })),
            onHit(sequence, target) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "BluePurpleExplosion"));
            },
        });
    }
};
PlagueAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Plague)
], PlagueAbilityHandler);
exports.PlagueAbilityHandler = PlagueAbilityHandler;
